import React, { Component } from 'react';
import MealImagesSection from './MealImagesSection';
import SalePlatformIcon from './SalePlatformIcon';

const base = 'dispatch_scan';

class DineInScannerView extends Component {
    render() {
        const {
            scannedItem,
            scannedItemSKU,
            originalItemImageLink,
            itemImage: itemWebCamImage,
        } = this.props;

        const customerName = scannedItem.customer_name;

        const customerNameToShow = customerName ? 
                                    (customerName.length > 13
                                        ? customerName.slice(0, 10) + '...'
                                        : customerName) : '';
        const referenceNumber = scannedItem.table_number ? scannedItem.table_number : scannedItem.bag_number;
        let orderNumberToShow = referenceNumber;
        let userInfoToShow = customerNameToShow ? customerNameToShow : (orderNumberToShow ? orderNumberToShow : "");
        let scannedInfoToShow = scannedItem.number_of_scanned_items + "/" + scannedItem.number_of_items;
        return (
            <div className={`${base}__scanner_box_view`}>
                <div className={`${base}__scanner_box_header_row`}>
                    <div className="icon_order_type">
                        <SalePlatformIcon 
                        scannedItem = {scannedItem}/>
                        <span className="dine_in_icon_text">{orderNumberToShow}</span>
                    </div>
                    <div className="order_info">
                        <p className={`${base}__user_info`}>
                            {userInfoToShow}
                        </p>
                        <p className={`${base}__scanned_info`}>
                        {scannedInfoToShow} items scanned
                        </p>
                    </div>
                </div>
                    <MealImagesSection
                        originalItemImageLink={originalItemImageLink}
                        itemWebCamImage={itemWebCamImage}
                        scannedItem={scannedItem}
                    />
            </div>
            );
        }
    }
export default DineInScannerView;